export default __webpack_public_path__ + "static/media/grafema_martini-contest_13.0d2b78b4.mp4";